module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG19a3dafacab41b61317e81f3236e4e25.19a3dafa.png";